// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3jsG-","block":"Footer_block__ZSnY4","content":"Footer_content__3rj9h"};